// Because default font size is 14 we want the icon to be 16px at that font size
$icon-size: calc(1em * 16 / 14);
$dot-size: 0.1875em;

.root {
  display: inline-flex;
  align-items: center;
  gap: var(--dixa-size-spacer-100);
}

.dots {
  display: grid;
  grid-template-columns: repeat(3, 1em);
  gap: 1em;
  font-size: $dot-size;

  &.withLabel {
    gap: 2em;
    font-size: 0.1em;
  }
}

.dot {
  $delay: 0.2s;
  width: 1em;
  height: 1em;
  border-radius: 1em;
  background-color: currentColor;
  animation: dot 1.4s infinite;

  &:nth-child(1) {
    animation-delay: $delay;
    transform-origin: right;
  }

  &:nth-child(2) {
    animation-delay: $delay * 2;
  }

  &:nth-child(3) {
    animation-delay: $delay * 3;
    transform-origin: left;
  }
}

@keyframes dot {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.2;
  }
  50% {
    transform: scale(1.4);
    opacity: 1;
  }
}

.icon {
  font-size: $icon-size;
  flex-shrink: 0;
  position: relative;
  width: 1em;
  height: 1em;
}

.star {
  position: absolute;
  transform-origin: bottom left;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;
  animation-fill-mode: both;

  &.large {
    $size: 0.78125em;
    $offset: 0.03125em;
    bottom: $offset;
    left: $offset;
    width: $size;
    height: $size;
    animation-name: star-large;
  }

  &.small {
    $size: 0.375em;
    $offset: 0.03125em;
    top: $offset;
    right: $offset;
    width: $size;
    height: $size;
    animation-name: star-small;
  }
}

@keyframes star-large {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
  30% {
    transform: scale(1.1);
    opacity: 1;
  }
  60% {
    transform: scale(0.8);
    opacity: 0.5;
  }
}

@keyframes star-small {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
  40% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  70% {
    transform: scale(0.8);
    opacity: 1;
  }
}
